module.exports = __webpack_public_path__ + "793e8d70ae62e1cfed04f2a970236ab3.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/nicole-chung.jpg
// module id = 450
// module chunks = 0